import { config } from 'environment/config';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';
import { buildDomainUrl } from 'shared/utils/domain';

type IsAllowedDomain = boolean;
export const updateBrowserTabMetadata = async (smartAssistant?: SmartAssistant): Promise<void> => {
  if (!smartAssistant) return;

  const whiteLabelIntegration = smartAssistant.whiteLabelIntegration;

  if (whiteLabelIntegration) {
    // Update the tab metadata
    document.title = smartAssistant.name;
    const faviconLinkLight = document.querySelector('#favicon-light');
    const faviconLinkDark = document.querySelector('#favicon-dark');
    if (smartAssistant.avatarUrl) {
      if (faviconLinkLight) faviconLinkLight.setAttribute('href', smartAssistant.avatarUrl);
      if (faviconLinkDark) faviconLinkDark.setAttribute('href', smartAssistant.avatarUrl);
    }
  } else {
    document.title = `Droxy - ${smartAssistant.name}`;
  }
};

export const validateAllowedDomain = (smartAssistant?: SmartAssistant): IsAllowedDomain => {
  if (!smartAssistant) return false;

  const currentHost = window.location.host;
  const whiteLabelIntegration = smartAssistant.whiteLabelIntegration;
  if (whiteLabelIntegration) {
    const fullDomain = buildDomainUrl(whiteLabelIntegration.subDomain, whiteLabelIntegration.domain, false);
    if (fullDomain !== currentHost && config.host !== currentHost) return false;
  } else if (config.host !== currentHost) return false;

  return true;
};

export const validateSmartAssistantEmbedding = (smartAssistant?: SmartAssistant): IsAllowedDomain => {
  if (!smartAssistant) return false;

  const isEmbedded = window.self !== window.top;
  if (!isEmbedded) {
    return true;
  }

  let currentUrl: URL;
  try {
    currentUrl = new URL(document.referrer);
  } catch {
    // If the referrer is not a valid URL, we can't validate the embedding. We assume it's allowed.
    return true;
  }

  return smartAssistant.websiteIntegration && smartAssistant.websiteIntegration.allowedDomains.length > 0
    ? smartAssistant.websiteIntegration.allowedDomains.some((domain) => {
        const domainUrl = new URL(domain);
        return domainUrl.hostname === currentUrl.hostname;
      })
    : true;
};
